import actions, * as thunks from './actions'
import * as components from './components'
import * as constants from './constants'
import createState from './createState'
import * as hooks from './hooks'
import translations from '../translations'
import reducer from './reducer'
import * as selectors from './selectors'

const { Message } = components
const { translator } = selectors

export {
  actions,
  thunks,
  components,
  constants,
  createState,
  hooks,
  reducer,
  selectors,
  translations,
  // FIXME remove these exports, and have clients use one of the above objects
  Message,
  translator
}
